import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRightPointer = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 4 7", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#006DC9", fillRule: "evenodd", stroke: "#006DC9", strokeWidth: 0.5, d: "M3.5 3.5c0 .052-.02.102-.054.139L.814 6.443c-.072.076-.188.076-.26 0-.072-.077-.072-.201 0-.278L3.056 3.5.554.835C.482.758.482.635.554.557c.072-.076.188-.076.26 0l2.632 2.804c.035.037.054.087.054.14" }));
const ForwardRef = forwardRef(SvgArrowRightPointer);
export { ForwardRef as ReactComponent };
